import { useEffect } from "react";

const BASE_TITLE = "7FIFTY7";

export const SEO = ({ title, description, schema }) => {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : `${BASE_TITLE}™ — WE NOW US NEXT`;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
    let scriptEl = null;
    if (schema) {
      scriptEl = document.createElement("script");
      scriptEl.type = "application/ld+json";
      scriptEl.text = JSON.stringify(schema);
      document.head.appendChild(scriptEl);
    }
    return () => {
      if (scriptEl) document.head.removeChild(scriptEl);
    };
  }, [title, description, schema]);
  return null;
};
